import { LoginInputType } from '../../services/session/types';
import { container } from 'tsyringe';
import { ValueStoreFacade } from '../../services/JWeb';
import TenantObserver, {
  TenantEvents
} from '../../services/tenantHandler/TenantObserver';
import { IUserService } from '../../services/userService';

export type SyncAuthenticationDataOnJWebValueStoreType = {
  userService: IUserService;
};

export default class SyncAuthenticationDataOnJWebValueStore {
  private _userService: IUserService;
  private _syncAuthenticationDataOnJWebValueStore: boolean;

  constructor({ userService }: SyncAuthenticationDataOnJWebValueStoreType) {
    this._userService = userService;
    const loginProps = container.resolve<LoginInputType>('LoginProps');
    this._syncAuthenticationDataOnJWebValueStore =
      loginProps?.syncAuthenticationDataOnJWebValueStore;
  }

  public async init(): Promise<void> {
    if (this._syncAuthenticationDataOnJWebValueStore === true) {
      this._setAuthenticationDataOnJWebValueStore();

      TenantObserver.subscribe(
        TenantEvents.SET_TENANT,
        this._setAuthenticationDataOnJWebValueStore
      );
    }
  }

  private _setAuthenticationDataOnJWebValueStore = () => {
    const authenticationData = this._userService.getAuthenticationData();

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    ValueStoreFacade.writeKeyValueToValueStore(
      'authenticationData',
      JSON.stringify(authenticationData)
    );
  };
}
